export const DESCRIPTION = 'Restart CAD to see updates';
export const BUTTON_TEXT = 'Restart';
export const MAX_TOAST_TIME = 2147483647;
